import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/system";
import HealingIcon from "@mui/icons-material/Healing";

const CustomListItem = styled(ListItem)(({ theme }) => ({
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
}));

const itemImgSrc = process.env.REACT_APP_IMAGE_SRC;
const btnColor = process.env.REACT_APP_SI180_BTNCOLOR;
const primColor = process.env.REACT_APP_SI180_PRIMCOLOR;
const secColor = process.env.REACT_APP_SI180_SECCOLOR;

const DietaryAllergyDialog = ({ open, onClose }) => {
  const history = useHistory();
  const selectedCustomer = JSON.parse(
    sessionStorage.getItem("selectedCustomer")
  );
  const [currentUser, setCurrentUser] = useState({
    firstName: selectedCustomer?.FirstName || "N/A",
    lastName: selectedCustomer?.LastName || "N/A",
    roomNumber: selectedCustomer?.Address1,
    residentImg: selectedCustomer?.SIC_Photo_Filename,
    allergens: selectedCustomer?.Allergens
      ? selectedCustomer.Allergens.split(",").filter(
          (allergen) => allergen.trim() !== ""
        )
      : ["None"],
  });

  const [isKeyFobDialogOpen, setIsKeyFobDialogOpen] = useState(false);

  const handleKeyFobDialogOpen = () => {
    setIsKeyFobDialogOpen(true);
  };

  const handleKeyFobDialogClose = () => {
    setIsKeyFobDialogOpen(false);
  };

  const handleKeyFobScan = () => {
    console.log("Scanning key fob...");
    setIsKeyFobDialogOpen(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div
        style={{
          textAlign: "center",
          color: primColor,
          margin: "1rem",
          paddingTop: "1rem",
          minWidth: "400px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            position: "relative",
          }}
        >
          <img
            src={
              currentUser.residentImg
                ? `${itemImgSrc}${currentUser.residentImg}`
                : `${itemImgSrc}respic.png`
            }
            alt={`${currentUser.firstName} ${currentUser.lastName}`}
            style={{
              width: "300px",
              height: "auto",
              borderRadius: "50%",
              border: `3px solid ${btnColor}`,
            }}
          />
          <Typography
            style={{
              fontSize: "1.25rem",
              lineHeight: "1.25",
              fontWeight: "500",
              color: "white",
              position: "absolute",
              bottom: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Adds a semi-transparent background to the text for better visibility
              padding: "5px 10px",
              borderRadius: "10px",
            }}
          >
            {currentUser.firstName} {currentUser.lastName}
          </Typography>
        </div>
      </div>
      <IconButton
        onClick={onClose}
        style={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white",
          backgroundColor: "#d33",
          borderRadius: "50%",
          padding: "12px",
        }}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <Box style={{ textAlign: "center" }}>
        <Button
          className="si180btnClear"
          sx={{
            textTransform: "capitalize",
          }}
          onClick={handleKeyFobDialogOpen}
        >
          Scan Key Fob
        </Button>
      </Box>
      <DialogContent>
        <Typography
          variant="h6"
          style={{
            fontWeight: "bold",
            backgroundColor: secColor,
            padding: ".75rem",
            lineHeight: 1.25,
          }}
        >
          Allergy Information
        </Typography>
        <List>
          {currentUser.allergens.map((allergen, index) => (
            <ListItem
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "0 .5rem",
              }}
            >
              <HealingIcon />
              <ListItemText
                primary={allergen}
                style={{
                  fontWeight: "bold",
                  marginLeft: ".5rem",
                }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <Dialog open={isKeyFobDialogOpen} onClose={handleKeyFobDialogClose}>
        <DialogTitle
          style={{
            fontSize: "x-large",
          }}
        >
          Scan Key Fob
        </DialogTitle>
        <DialogContent>
          <Typography
            style={{
              fontSize: "1.15rem",
            }}
          >
            Please hold your key fob near the scanner to continue.
          </Typography>
        </DialogContent>
        <DialogActions
          style={{
            marginBottom: "1rem",
          }}
        >
          <Button
            onClick={handleKeyFobDialogClose}
            sx={{
              fontSize: "1.15rem",
              backgroundColor: "#d33",
              width: "120px",
              height: "60px",
              "&:hover": { backgroundColor: "#b22" },
            }}
            autoFocus
          >
            Cancel
          </Button>
          <Button
            onClick={handleKeyFobScan}
            sx={{
              fontSize: "1.15rem",
              backgroundColor: "#265e08",
              width: "120px",
              height: "60px",
              "&:hover": { backgroundColor: "#1e4b06" },
            }}
            autoFocus
          >
            Scan
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default DietaryAllergyDialog;
